import { IntegrationType } from '../models/enums/integrationEnums';

/**
 * Maps frontend integration types to backend integration types
 * VOA -> Asset, VOIE -> EmploymentIncome
 */
export const mapFrontendToBackendType = (frontendType: IntegrationType): string => {
  const mapping: Record<IntegrationType, string> = {
    [IntegrationType.VOA]: 'Asset',
    [IntegrationType.VOIE]: 'IncomeEmployment',
    [IntegrationType.Flood]: 'Flood',
    [IntegrationType.LOS]: 'Los',
    [IntegrationType.Underwrite]: 'Underwrite',
    [IntegrationType.Credit]: 'Credit',
    [IntegrationType.Title]: 'Title',
    [IntegrationType.PropertyData]: 'PropertyData',
    [IntegrationType.Fees]: 'Fees',
    [IntegrationType.Pricing]: 'Pricing',
    [IntegrationType.Auw]: 'Auw',
  };
  return mapping[frontendType] || frontendType;
};
